import RequestManager from "src/requests/RequestManager";
import { Lineup, Player } from "../interfaces";
import { isMockDataActive, lineup as resultMock } from "../mockData";
import { LineupTask } from "../tasks";
import { parsePlayer } from "../utils";

// Se usa en VCardPartido/Alineación
export default async function getLineup(matchId: string): Promise<{
    homeLineup: Lineup,
    awayLineup: Lineup
}> {
    const task = new LineupTask(matchId);
    let result;
    if (isMockDataActive) {
        result = resultMock;
    } else {
        result = await RequestManager.addRequest(task);
    }
    
    const home = result.homeLineup || {};
    const away = result.awayLineup || {};

    const homeLineup: Lineup = {
        formation: (home.team && home.team.properties && home.team.properties.formation) || "",
        players: (home.teamMembers && home.teamMembers.map((player: any) => parsePlayer(player))) || [],
        coach: parsePlayer((home.coaches && home.coaches[0]) || [])
    }

    const awayLineup: Lineup = {
        formation: (away.team && away.team.properties && away.team.properties.formation) || "",
        players: (away.teamMembers && away.teamMembers.map(parsePlayer)) || [],
        coach: parsePlayer((away.coaches && away.coaches[0]) || [])
    }

    return {
        homeLineup,
        awayLineup
    }
};


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getLineup.ts